import { render, staticRenderFns } from "./wxfemale.vue?vue&type=template&id=6a617686&scoped=true&"
import script from "./wxfemale.vue?vue&type=script&lang=js&"
export * from "./wxfemale.vue?vue&type=script&lang=js&"
import style0 from "./wxfemale.vue?vue&type=style&index=0&id=6a617686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a617686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a617686')) {
      api.createRecord('6a617686', component.options)
    } else {
      api.reload('6a617686', component.options)
    }
    module.hot.accept("./wxfemale.vue?vue&type=template&id=6a617686&scoped=true&", function () {
      api.rerender('6a617686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/wxfemale.vue"
export default component.exports